import { useMutation } from '@apollo/client';

import notificationService from 'services/notificationService';

import {
  IStartClientSessionRequest,
  IStartClientSessionResponse,
} from '../../schemas';
import { START_CLIENT_SESSION } from '../../schemas/hosts';
import { HOSTS_DATA } from '../useHostsData/schema';
import { TUseStartClientSession } from './interfaces';

export const useStartClientSession: TUseStartClientSession = (t) => {
  const [startClientSession] = useMutation<
    IStartClientSessionResponse,
    IStartClientSessionRequest
  >(START_CLIENT_SESSION, {
    refetchQueries: [HOSTS_DATA],
    onCompleted: (data) => {
      if (!data.startClientSession) return;

      return notificationService.info({
        dismiss: 3,
        t,
        type: 'success',
        title: t('host.notification.start_post_payment.success'),
        leftDescription: data.startClientSession.hosts[0].host.alias,
      });
    },
  });

  return startClientSession;
};
